// rspack picks this up via the `.web.ts` extension priority. html-loader
// returns the HTML as a string on `.default`, which the iframe-based WebView
// shim renders via `srcDoc`.
const source = { html: require('./f2chart.html').default as string }

export default source
